<template>
  <v-layout wrap justify-space-between>
    <v-btn
      v-for="item in sortList"
      :key="item.value"
      :value="item.value"
      :color="item.value === innerValue ? 'primary' : 'light-grey'"
      class="rounded-5 font-weight-black"
      @click="$emit('update:sort', item.value)"
      style="flex-basis: 49%"
      depressed
    >
      {{ item.label }}
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  props: {
    // label-value pair
    sortList: {
      type: Array,
      default: () => [],
    },

    sort: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      innerValue: null,
    }
  },

  watch: {
    sort: {
      immediate: true,
      handler(val) {
        this.innerValue = val
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
